import URL from './url'
import http from '@/utils/httpUtils'

export default {
  /** magic org */
  magicDeptRoot(params) {
    return http.get(URL.API_MAGIC_DEPT_ROOT, { ...params, smallProgramType: 3 })
  },
  magicDeptList(params) {
    return http.get(URL.API_MAGIC_DEPT_LIST, { ...params, smallProgramType: 3 })
  },
  magicDeptNode(params) {
    return http.post(URL.API_MAGIC_DEPT_NODE, {
      ...params,
      smallProgramType: 3
    })
  },
  magicCheckLogin(params) {
    return http.put(URL.API_MAGIC_CUSTOM_CHECK_LOGIN, {
      ...params,
      smallProgramType: 3
    })
  },
  magicLoginByUnionid(params) {
    return http.post(URL.API_PERSONAL_CUSTOM_LOGIN_BY_UNIONID, {
      ...params,
      smallProgramType: 3
    })
  },
  magicOrgList(params) {
    return http.get(URL.API_MAGIC_CUSTOM_LIST_SIMPLE_ORG, {
      ...params,
      smallProgramType: 3
    })
  },
  magicCheckPublic(params) {
    return http.post(URL.API_MAGIC_WECHAT_CHECK_PUBLIC, {
      ...params,
      smallProgramType: 3
    })
  },
  magicLogin(params) {
    return http.post(URL.API_PERSONAL_PROGRAM_LOGIN, {
      ...params,
      smallProgramType: 3
    })
  },
  magicRegister(params) {
    return http.post(URL.API_PERSONAL_PROGRAM_REGISTER, {
      ...params,
      smallProgramType: 3
    })
  },
  magicGetMobile(params) {
    return http.post(URL.API_PERSONAL_PROGRAM_MOBILE, {
      ...params,
      smallProgramType: 3
    })
  },
  getAccountSimpleness(params) {
    return http.get(URL.API_COMMON_ACCOUNT_SIMPLENESS, {
      ...params,
      smallProgramType: 3
    })
  },
  createAccountRegister(params) {
    return http.post(URL.API_COMMON_ACCOUNT_REGISTER_TOGETHER, {
      ...params,
      smallProgramType: 3
    })
  },
  accountBind(params) {
    return http.post(URL.API_COMMON_ACCOUNT_BIND, {
      ...params,
      smallProgramType: 3
    })
  },
  checkIsBindMDAccount(params) {
    return http.post(URL.API_WECHAT_PROGRAM_CHECKAUTH, {
      ...params,
      smallProgramType: 3
    })
  },
  getAccountDetail(params) {
    // API_COMMON_ACCOUNT_DETAIL
    return http.get(URL.API_COMMON_ACCOUNT_DETAIL, {
      ...params,
      smallProgramType: 3
    })
  },
  getLoginToken(params) {
    // API_COMMON_ACCOUNT_DETAIL
    return http.get(URL.API_COMMON_ACCOUNT_DETAIL, {
      ...params,
      smallProgramType: 3
    })
  },
  queryDefaultOrgByAccountId(params) {
    // API_COMMON_ACCOUNT_DETAIL
    return http.get(URL.API_COMMON_ORG_LIST, {
      ...params,
      smallProgramType: 3
    })
  },
  findAllOrgBasicInfoByAccountId(params) {
    return http.get(URL.API_COMMON_ALL_ORG_LIST, {
      ...params,
      smallProgramType: 3
    })
  },
  getMagicMemberInfo(params) {
    return http.get(URL.API_MAGIC_MEMBER_INFO, {
      ...params,
      smallProgramType: 3
    })
  },
  uploadFaceImage(params) {
    // uploadFile
    return http.magicUploadFile(URL.API_MAGIC_FACE_EDIT, params)
  },
  // 成员删除
  deleteMemberByMember(postData) {
    return new Promise((resolve, reject) => {
      http
        .delete(URL.API_MEMBER_DELETE, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 搜索成员
  apiAddressMemberSearch(postData) {
    return http.get(URL.API_MEMBER_LISTMEMBERS, postData)
  },
  // 分页查询外部人员列表
  apiExternalList(postData) {
    return http.get(URL.API_EXTERNAL_LIST_BY_PAGE, postData)
  },
  apiAccountUnbind(postData) {
    return http.post(URL.apiAccountUnbind, postData)
  }
  //
  //
  /** magic org */
}
